import {toURL} from '@homeaway/search-url-parser';

const getFilterFromSubDestination = (subDestination = {}) => {
    const {
        filter: {
            id
        } = {}
    } = subDestination;

    return id ? [`filter:${id}`] : [];
};

export const constructSearchRequest = (searchEvent) => {
    const {adultsCount, childrenCount, petIncluded} = searchEvent.guests || {};
    const filter = getFilterFromSubDestination(searchEvent.subDestination);

    return {
        q: searchEvent.destination,
        arrival: searchEvent.checkIn,
        departure: searchEvent.checkOut,

        adultsCount: adultsCount || 0,
        childrenCount: childrenCount || 0,
        petIncluded: !!petIncluded,
        filter
    };
};

export const sentenceCase = (string) =>
    string ? string.charAt(0).toUpperCase() + string.slice(1) : string;

const applyPropertyTypeRefinement = (path, propertyType) => {
    if ((propertyType === 'property_type_all') || !propertyType) {
        return path;
    }

    const propertyTypeValue = 'Property+Type:'.concat(
        sentenceCase(propertyType.replace('property_type_', ''))
    );

    return path.includes('?')
        ? path.replace('?', `/${propertyTypeValue}?`)
        : path.concat(`/${propertyTypeValue}`);
};

const refinerMap = {
    propertyType: applyPropertyTypeRefinement
};

export const generateSearchPageLink = (searchRequest, refinements) => {

    const searchUrl = toURL(searchRequest);

    return Object.keys(refinements)
        .map((key) => ({key, value: refinements[key]}))
        .reduce(
            (acc, {key, value}) => (refinerMap[key] || ((x) => x))(acc, value),
            searchUrl
        );
};

